import { DataActions } from "../store/data/actions";

/**
 * Check if feature flag overrides are allowed.
 * Requires debug mode to be enabled.
 */
export function isFeatureFlagOverrideAllowed(): boolean {
    return window.driveApp?.store?.getState()?.data?.debugMode ?? false;
}

/**
 * Get all feature flag overrides from Redux state (for UI display).
 * Returns empty object if debug mode is off.
 */
export function getFeatureFlagOverrides(): Record<string, boolean> {
    if (!isFeatureFlagOverrideAllowed()) {
        return {};
    }
    return window.driveApp?.store?.getState()?.data?.featureFlagOverrides ?? {};
}

/**
 * Set a feature flag override.
 * This modifies featureFlags directly so all consumers automatically see the change.
 * Only works when debug mode is enabled.
 */
export function setFeatureFlagOverride(flagName: string, isEnabled: boolean): void {
    if (!isFeatureFlagOverrideAllowed()) {
        return;
    }

    window.driveApp?.store?.dispatch(DataActions.setFeatureFlagOverride({ flagName, isEnabled }));
}

/**
 * Clear a single override, restoring the original server value.
 * Only works when debug mode is enabled.
 */
export function clearFeatureFlagOverride(flagName: string): void {
    if (!isFeatureFlagOverrideAllowed()) {
        return;
    }

    window.driveApp?.store?.dispatch(DataActions.clearFeatureFlagOverride(flagName));
}

/**
 * Clear all overrides, restoring all original server values.
 * Note: This bypasses isFeatureFlagOverrideAllowed() because it's called
 * when debug mode is turned off to clean up overrides.
 */
export function clearAllFeatureFlagOverrides(): void {
    window.driveApp?.store?.dispatch(DataActions.clearAllFeatureFlagOverrides());
}
